import { $descendantsMatching } from '@lexical/utils'
import { $getRoot, $isElementNode, $isLineBreakNode, $isTextNode, LexicalEditor, LexicalNode } from 'lexical'

import { $isMentionNode, MentionNode } from './mentions/MentionNode'

const $isEmptyNode = (node: LexicalNode) =>
    ($isElementNode(node) && node.isEmpty()) || ($isTextNode(node) && node.getTextContent().trim() === '') || $isLineBreakNode(node)

/**
 * Trim the last node if its empty, repeat until the last node is not empty
 * @returns The number of nodes trimmed
 */
export const $trimLastNode = (): number => {
    const root = $getRoot()
    let lastDesc = root.getLastDescendant()

    let trimmed = 0
    while (lastDesc && $isEmptyNode(lastDesc)) {
        lastDesc.remove()
        lastDesc = $getRoot().getLastDescendant()
        trimmed++
    }

    return trimmed
}

/**
 * Get all MentionNodes from the editor state.
 * Must be called within editor.read() or editor.update() callback.
 */
export const $getMentionNodes = () => $descendantsMatching($getRoot().getChildren(), $isMentionNode)

/**
 * Get all MentionNodes from the editor.
 * Reads the editor state and returns all MentionNode instances.
 */
export const getMentionNodes = (editor: LexicalEditor): MentionNode[] => editor.read(() => $getMentionNodes())

export const getMentionItems = (editor: LexicalEditor) =>
    editor.read(() => {
        const nodes = $getMentionNodes()
        const mentions = nodes.map(n => n.toMentionItem())
        return mentions
    })

export const getApiMentions = (editor: LexicalEditor) =>
    getMentionItems(editor)
        .filter(item => item.type === 'user')
        .map(item => ({ resource_id: Number(item.id), resource_type: item.type }))
